const DraftForm = (
  data,
  companyId,
  userFullName,
  userCompanyName,
  userCompanyType,
  userCountry,
) => {
  const Draft = {
    affectsCulturalHeritage:
      data.affectsCulturalHeritage !== '' ? data.affectsCulturalHeritage : null,
    answerActivityQuestion: data.answerActivityQuestion
      ? data.answerActivityQuestion
      : [],
    companyId: companyId,
    companyName: userCompanyName,
    companyAddress: data.companyAddress ? data.companyAddress : '',
    companyPhone: data.companyPhone ? data.companyPhone : '',
    companyTypeId: parseInt(userCompanyType),
    detailActivity: data.detailActivity ? data.detailActivity : '',
    detailAdaptationAction: data.detailAdaptationAction
      ? data.detailAdaptationAction
      : '',
    detailAffectsCulturalHeritage: data.detailAffectsCulturalHeritage
      ? data.detailAffectsCulturalHeritage
      : '',
    detailClimateThreat: data.detailClimateThreat
      ? data.detailClimateThreat
      : '',
    detailSector: data.detailSector ? data.detailSector : '',
    draft: true,
    idAdaptationAction: data.idAdaptationAction
      ? data.idAdaptationAction
      : null,
    idBusinessLine: data.idBusinessLine ? data.idBusinessLine : null,
    idClimateThreat: data.idClimateThreat ? data.idClimateThreat : null,
    idCountry: parseInt(userCountry),
    idCurrency: data.idCurrency ? data.idCurrency : null,
    idDepartment: data.idDepartment ? data.idDepartment : null,
    idMunicipality: data.idMunicipality ? data.idMunicipality : null,
    idSector: data.idSector ? data.idSector : null,
    idSectorActivity: data.idSectorActivity ? data.idSectorActivity : null,
    isInProtectedArea:
      data.isInProtectedArea !== '' ? data.isInProtectedArea : null,
    protectedAreaLocation: data.protectedAreaLocation
      ? data.protectedAreaLocation
      : '',
    legalRepresentativeFullName: data.legalRepresentativeFullName
      ? data.legalRepresentativeFullName
      : '',
    legalRepresentativeIdentification: data.legalRepresentativeIdentification
      ? data.legalRepresentativeIdentification
      : '',
    negativeImpact: data.negativeImpact ? data.negativeImpact : [],
    quantityEmployees: data.quantityEmployees ? data.quantityEmployees : '',
    requiredAmountSourceCurrency: data.requiredAmountSourceCurrency
      ? data.requiredAmountSourceCurrency
      : 0,
    requiredAmountDollarsCurrency: data.requiredAmountDollarsCurrency
      ? data.requiredAmountDollarsCurrency
      : 0,
    subprojectName: data.subprojectName ? data.subprojectName : '',
    userFullName: userFullName,
    detailBusinessLine: '',
    idForm: data.idForm ? data.idForm : null,
    idUserB2C: data.idUserB2C,
  }
  return Draft
}

export default DraftForm
